import { Controller } from 'react-hook-form';
import { FormError, HelpText } from '@Forms/fields.jsx';
import { lazyBoolean } from '@helpers';

const ToggleField = ({
  control,
  error,
  helpText,
  label,
  name,
  register,
  options = {},
  ...props
}) => {
  const {
    onChange: optionOnChange,
    onBlur: optionOnBlur,
    disabled: optionDisabled,
    ...rules
  } = options;

  const {
    onChange: propOnChange,
    onBlur: propOnBlur,
    disabled: propDisabled,
    ...restProps
  } = props;

  const disabled = propDisabled ?? optionDisabled;

  const wrap = (input) => (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-switch ` +
        (error ? 'sb-form-item-error' : '')
      }
    >
      <div className="sb-form-item-label">{label}</div>
      <div className="sb-form-item-content">
        <div className="sb-form-item-switch-wrap">
          <label className="sb-switch">
            {input}
            <span className="sb-switch-slider sb-round" />
          </label>
        </div>
        {helpText && <HelpText message={helpText} />}
        {error && <FormError message={error.message} />}
      </div>
    </div>
  );

  // checkbox for lazyboolean
  if (control) {
    return wrap(
      <Controller
        name={name}
        control={control}
        rules={rules}
        disabled={disabled}
        render={({ field }) => (
          <input
            type="checkbox"
            ref={field.ref}
            name={field.name}
            checked={lazyBoolean(field.value)}
            disabled={disabled}
            onChange={(e) => {
              const { checked } = e.target;
              field.onChange(checked);
              optionOnChange?.(e);
              propOnChange?.(e);
            }}
            onBlur={(e) => {
              field.onBlur();
              optionOnBlur?.(e);
              propOnBlur?.(e);
            }}
            {...restProps}
          />
        )}
      />,
    );
  }
  // backward compatibility for legacy boolean
  return wrap(
    <input type="checkbox" {...register(name, options)} {...props} />,
  );
};

export default ToggleField;
